import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskQueuesManageViewRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-manage-view',
	path: '/jira/servicedesk/projects/:projectKey/queues/queue-settings',
	exact: true,
};
